import {SortType} from '../../search/search-types';

export type ContainersResponse = {
    defaultContainer: string;
    containers: ContainerAttributes[];
};

export type SettingsState = {
    containerName: string;
    technicalDetails: boolean;
    manualValidation: boolean;
    fieldSpecificSearch: boolean;
    containers: {
        [containerName: string]: ContainerAttributes;
    };
};

export type ContainerAttributes = {
    name: string;
    queryFields: string[];
    suggestFields: string[];
    facetFields: string[];
    sortOptions: SortType[];
};

export const MESSAGE_BOX_SETTINGS_ID = 'message-box__settings';
